import { EventEmitter } from '@angular/core';
import { ATTRIBUTION_PERFORMANCE_CHART_CONFIGURABLE_OPTIONS, ATTRIBUTION_PERFORMANCE_CHART_OPTIONS, } from 'SecuritiesApp/ts/features/attribution-relative/constants';
import { PerformancePeriodicity, } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../charts/static/charts/ts/features/general-chart/components/general-chart/general-chart.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i4 from "../../../module-upsell/module-upsell.component";
import * as i5 from "../attribution-relative-zoom-controls/attribution-relative-zoom-controls.component";
const _c0 = (a0, a1) => ({ "min-height-220": a0, "overflow-auto": a1 });
function AttributionPerformanceChartComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function AttributionPerformanceChartComponent_ycn_loading_symbol_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 13);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function AttributionPerformanceChartComponent_div_11_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(category_r2.name);
} }
function AttributionPerformanceChartComponent_div_11_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(category_r3.portfolioReturn);
} }
function AttributionPerformanceChartComponent_div_11_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(category_r4.benchmarkReturn);
} }
function AttributionPerformanceChartComponent_div_11_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const category_r5 = ctx.$implicit;
    i0.ɵɵclassMap(category_r5.excessReturnCellCssClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(category_r5.excessReturn);
} }
function AttributionPerformanceChartComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "div", 15)(2, "ycn-general-chart", 16);
    i0.ɵɵelementStart(3, "div", 17)(4, "div", 18);
    i0.ɵɵelement(5, "div", 19);
    i0.ɵɵtemplate(6, AttributionPerformanceChartComponent_div_11_div_6_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 21)(8, "div", 22)(9, "span", 23);
    i0.ɵɵtext(10, "Portfolio Return");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, AttributionPerformanceChartComponent_div_11_div_11_Template, 2, 1, "div", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 21)(13, "div", 22)(14, "span", 25);
    i0.ɵɵtext(15, "Benchmark Return");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, AttributionPerformanceChartComponent_div_11_div_16_Template, 2, 1, "div", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 21)(18, "div", 22)(19, "strong", 26);
    i0.ɵɵtext(20, "Excess Return");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(21, AttributionPerformanceChartComponent_div_11_div_21_Template, 3, 3, "div", 27);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("chartJsonData", ctx_r0.chartData)("chartOptions", ctx_r0.chartOptions)("configurableOptions", ctx_r0.chartConfigurableOptions);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.displayCategories);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r0.displayCategories);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r0.displayCategories);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r0.displayCategories);
} }
export class AttributionPerformanceChartComponent {
    constructor() {
        this.errorMessage = '';
        this.asOfDateOption = '';
        this.periodicityChangeHandler = new EventEmitter();
        this.chartConfigurableOptions = ATTRIBUTION_PERFORMANCE_CHART_CONFIGURABLE_OPTIONS;
        this.chartOptions = ATTRIBUTION_PERFORMANCE_CHART_OPTIONS;
        this.USER = window.USER;
    }
    updatePeriodicity(periodicity) {
        this.periodicityChangeHandler.emit(periodicity);
    }
}
AttributionPerformanceChartComponent.ɵfac = function AttributionPerformanceChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionPerformanceChartComponent)(); };
AttributionPerformanceChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionPerformanceChartComponent, selectors: [["ycn-attribution-performance-chart"]], inputs: { performancePeriodicity: "performancePeriodicity", chartData: "chartData", displayCategories: "displayCategories", loading: "loading", errorMessage: "errorMessage", asOfDateOption: "asOfDateOption" }, outputs: { periodicityChangeHandler: "periodicityChangeHandler" }, standalone: false, decls: 12, vars: 10, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], [3, "periodicityChangeHandler", "performancePeriodicity", "asOfDateOption"], [1, "panel-content", 3, "ngClass"], [3, "title"], ["class", "toast toast-error", 4, "ngIf"], [3, "loaderMessage", 4, "ngIf"], ["class", "chart-vertical-bars min-width-max-content", 4, "ngIf"], [1, "toast", "toast-error"], [1, "toast-text"], [3, "loaderMessage"], [1, "chart-vertical-bars", "min-width-max-content"], [1, "chart-options"], [3, "chartJsonData", "chartOptions", "configurableOptions"], [1, "chart-data"], [1, "chart-data-header"], [1, "chart-data-title"], ["class", "chart-data-title d-flex align-items-end justify-content-center", 4, "ngFor", "ngForOf"], [1, "chart-data-row"], [1, "chart-data-cell"], [1, "chart-legend-item-title", "bullet-1"], ["class", "chart-data-cell", 4, "ngFor", "ngForOf"], [1, "chart-legend-item-title", "bullet-2"], [1, "chart-legend-item-title", "bullet-0"], ["class", "chart-data-cell", 3, "class", 4, "ngFor", "ngForOf"], [1, "chart-data-title", "d-flex", "align-items-end", "justify-content-center"]], template: function AttributionPerformanceChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, "Performance Chart");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "ycn-attribution-relative-zoom-controls", 5);
        i0.ɵɵlistener("periodicityChangeHandler", function AttributionPerformanceChartComponent_Template_ycn_attribution_relative_zoom_controls_periodicityChangeHandler_6_listener($event) { return ctx.updatePeriodicity($event); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelement(8, "ycn-module-upsell", 7);
        i0.ɵɵtemplate(9, AttributionPerformanceChartComponent_div_9_Template, 3, 1, "div", 8)(10, AttributionPerformanceChartComponent_ycn_loading_symbol_10_Template, 1, 1, "ycn-loading-symbol", 9)(11, AttributionPerformanceChartComponent_div_11_Template, 22, 7, "div", 10);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("performancePeriodicity", ctx.performancePeriodicity)("asOfDateOption", ctx.asOfDateOption);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0, ctx.errorMessage, ctx.USER.authenticated));
        i0.ɵɵadvance();
        i0.ɵɵproperty("title", "Performance Chart");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading && !ctx.errorMessage);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.GeneralChartComponent, i3.LoadingSymbolComponent, i4.ModuleUpsellComponent, i5.AttributionRelativeZoomControlsComponent], encapsulation: 2 });
